import { WorkFlowStepWarningComponent } from "./work-flow-step-warning.component";
export const WorkFlowStepWarningModule = angular
    .module('workFlowStepWarning', [])
    .component(WorkFlowStepWarningComponent.selector, WorkFlowStepWarningComponent.component)
    .name;
//# sourceMappingURL=work-flow-step-warning.module.js.map